import React from "react";
import { ImPointRight } from "react-icons/im";
import SectionHead from "../common/SectionHead";
import { profile, intro, bio, bioClosing, timeline, interests } from "../../data/content";

function Facts() {
  return (
    <div className="container">
      <ul className="facts">
        {profile.facts.map(({ label, value }) => (
          <li className="facts__item" key={label}>
            <span className="facts__label">{label}</span>
            <span className="facts__value">{value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function About() {
  return (
    <section className="section" id="about">
      <div className="container">
        {/* intro.lead is used as the hero lede, so it is not repeated here. */}
        <SectionHead eyebrow="Know who I'm" title={intro.heading} />

        <div className="about__grid">
          <div>
            <div className="prose">
              <p>
                Hi everyone, I am <strong>Dharmik Batra</strong> from{" "}
                <strong>Haryana, India.</strong>
              </p>
              {bio.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              <p>
                {bioClosing.before}
                <a
                  href={bioClosing.linkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {bioClosing.linkLabel}
                </a>
                {bioClosing.after}
              </p>
            </div>

            <h3 className="timeline__heading">{intro.timelineHeading}</h3>
            <ol className="timeline">
              {timeline.map(({ period, title, details }) => (
                <li className="timeline__item" key={period + title}>
                  <span className="timeline__period">{period}</span>
                  <h4 className="timeline__title">{title}</h4>
                  <p className="timeline__details">{details}</p>
                </li>
              ))}
            </ol>

            <blockquote className="about__quote">
              <p>“{profile.quote}”</p>
              <footer>{profile.quoteAuthor}</footer>
            </blockquote>
          </div>

          <div className="card interests">
            <p className="interests__title">Beyond Work &amp; Code</p>
            <ul className="interests__list">
              {interests.map(({ label }) => (
                <li className="interests__item" key={label}>
                  <ImPointRight />
                  {label}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export { Facts };
export default About;
